const dateTimeFormats = {
  'ru': {
    default: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    },
    short: {
      month: 'short',
      year: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
  },
  'en': {
    default: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    },
    short: {
      month: 'short',
      year: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
  }
}

export default dateTimeFormats;
